import { render, staticRenderFns } from "./ModalLegalEmpresas.vue?vue&type=template&id=2f19022c&"
import script from "./ModalLegalEmpresas.vue?vue&type=script&lang=js&"
export * from "./ModalLegalEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports